import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as o } from "react";
import { I as t } from "../../../../IconBase-CxZyIWw2.js";
const i = o((r, e) => /* @__PURE__ */ s.jsx(
  t,
  {
    ref: e,
    ...r,
    image: (a) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...a,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_3468",
              width: 16,
              height: 16,
              x: 0,
              y: 0,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "currentColor",
                  d: "m9.06 8 6.72-6.72c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0L8 6.94 1.28.22a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06L6.94 8 .22 14.72c-.29.29-.29.77 0 1.06.15.15.34.22.53.22s.38-.07.53-.22L8 9.06l6.72 6.72c.15.15.34.22.53.22s.38-.07.53-.22c.29-.29.29-.77 0-1.06z"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_3468)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) })
        ]
      }
    )
  }
));
i.displayName = "AgencyCrossIcon";
export {
  i as AgencyCrossIcon,
  i as default
};
//# sourceMappingURL=index.js.map
